module.exports = __webpack_public_path__ + "static/img/contestant-front.35e8690.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contestant-front.jpg
// module id = LpyW
// module chunks = 1